import { CurrentSettingsVersionDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCurrentCompanySettingsVersion = () => {
  const [currentCompanySettingsVersion, { loading }] = useMutation(CurrentSettingsVersionDocument, {
    extractorFn: (data) => data.attendanceMutations.currentAttendanceCompanySettingsVersion,
  })

  const currentSettingVersion = () => {
    return currentCompanySettingsVersion({ variables: {} })
  }

  return {
    loading,
    currentSettingVersion,
  }
}
